<template>
  <div id="scrollableDiv" class="no-scrollbar chat-scroll-reverse"
    :style="{ flex: maxHeight ? 'none' : '1 1 auto', overflowY: 'auto', padding: '10px', maxHeight: maxHeight || 'none', minHeight: minHeight || 'auto' }"
    @scroll="handleChatScroll" ref="infiniteChatScrollContainer">
    <!-- column-reverse 下内容不足一屏时，该占位元素的 auto margin 吸收全部剩余空间，使消息顶部对齐 -->
    <div class="chat-scroll-bottom-spacer"></div>
    <!-- 错误提示（如私有会话） -->
    <div v-if="chat.errorMsg" style="padding: 40px 20px; text-align: center;">
      <van-icon name="lock" size="48" color="#F07058" />
      <div style="margin-top: 16px; font-size: 14px; color: #F07058;">{{ chat.errorMsg }}</div>
    </div>
    <div v-for="record in chat.chatMsgs" v-bind:key="record.msgId" :data-msg-id="record.msgId"
      style="margin:8px 0px;width:100%;">
      <!-- 系统消息 -->
      <div v-if="record.system == '1'">
        <div v-if="record.contentType == 'plaintext' || record.contentType == 'text'"
          style="background: #F7F5F2;padding: 10px;border-radius: 4px;font-size:0.85rem;color: #8A8A8A;">
          <van-icon color="#E8543A" name="info-o" size="12" style="position:relative;top:1px;margin-right: 2px;" />
          {{ record.msg }}
        </div>
      </div>
      <!-- 普通消息：已撤回的占位展示（不删除消息位置），仅显示撤回提示、不展示原内容 -->
      <div v-if="record.system != '1' && record.revoked == '1'" class="message-row message-revoked-row">
        <div class="msg-revoked-text">
          <van-icon name="revoke" size="11" style="margin-right: 3px;position: relative;top: 0.5px;" />
          <!-- revokedBy=2 为平台处置（内容安全人工复核拦截），区别于本人撤回 -->
          {{ record.revokedBy == '2' ? $t('msg_revoked_platform') : (record.direction == '0' ? $t('msg_revoked_self') : $t('msg_revoked_other')) }}
        </div>
      </div>
      <div v-else-if="record.system != '1'" class="message-row"
        :class="record.direction == '0' ? 'message-right' : 'message-left'"
        @contextmenu.prevent="showMessageActions(record, $event)">
        <!-- 对方消息：头像在左侧 -->
        <template v-if="record.direction == '1'">
          <div class="message-avatar" @click="onAvatarClick(record)"
            :style="record.fromUserId != platformUserId && isUserChat ? 'cursor: pointer;' : ''">
            <img v-if="record.fromUserId == platformUserId" src="/static/logo-transparent.png"
              :class="['avatar-img', { 'ai-thinking-spin': record.isThinking }]" />
            <img v-else-if="targetAvatarUrl" :src="$common.getFullImageUrl(targetAvatarUrl, $config, 's')"
              class="avatar-img" />
            <div v-else class="avatar-placeholder">{{ (targetUserName || $t('anonymous'))[0] }}</div>
          </div>
          <div class="message-content-wrapper" @touchstart="handleTouchStart(record, $event)" @touchend="handleTouchEnd($event)">
            <div class="msg-body">
              <!-- 引用块：被引用消息已撤回时显示撤回提示 -->
              <div v-if="record.reply && record.reply.msgId" class="msg-reply-block">
                <div v-if="replyNameText(record)" class="msg-reply-name">{{ replyNameText(record) }}</div>
                <div class="msg-reply-summary">{{ replySummaryText(record) }}</div>
              </div>
              <div v-if="record.contentType == 'assistant'" style="font-size:0.85rem;padding:2px 0px;color: #1A1A1A;">
                <!-- AI 生成内容显著标识（合规要求） -->
                <span style="display: inline-block; margin-bottom: 4px; padding: 1px 5px; background: #FEF0ED; border: 0.5px solid #F8A090; border-radius: 4px; font-size: 9px; color: #8A8A8A; font-weight: 500; line-height: 1.5;">{{ $t('ai_generated_label') }}</span>
                <!-- Think 内容展示 -->
                <div v-if="record.isThinking" style="margin-bottom: 8px;">
                  <div style="display: flex;align-items: center;font-size: 0.7rem;color: #8A8A8A;">
                    <van-icon name="clock-o" size="12" style="margin-right: 4px;flex-shrink:0;" />
                    <span style="flex-shrink:0;">{{ $t('thinking') }}...</span>
                    <span v-if="record.thinkContent" class="thinking-latest-text"><span>{{ record.thinkContent }}</span></span>
                  </div>
                </div>
                <div v-if="record.parsedMsg && record.parsedMsg.trim()" v-html="record.parsedMsg"
                  style="white-space: pre-line;word-break: break-all;" class="html-content">
                </div>
                <div v-if="record.actions && record.actions.length > 0" style="margin-top: 10px;">
                  <div v-for="(action, index) in record.actions" :key="index">
                    <van-button v-if="action.type === 'pick_location' && mapFeatureEnabled" size="small" type="primary"
                      @click="handlePickLocation(action, record.msgId)" style="margin-top: 5px;">
                      <van-icon name="location-o" style="margin-right: 4px;" />
                      {{ action.description || $t('select_location') }}
                    </van-button>
                    <van-button v-if="action.type === 'pick_date'" size="small" type="primary"
                      @click="handlePickDate(action, record.msgId)" style="margin-top: 5px;">
                      <van-icon name="calendar-o" style="margin-right: 4px;" />
                      {{ action.description || $t('select_date') }}
                    </van-button>
                    <!-- 设为公开（对齐 client/ ai_chat_page case 'set_public'：AI 消息内嵌动作，经 ChatBox 确认后调接口） -->
                    <van-button v-if="action.type === 'set_public'" size="small" type="primary"
                      @click="$emit('set-public')" style="margin-top: 5px;">
                      <van-icon name="eye-o" style="margin-right: 4px;" />
                      {{ action.description || $t('session_setPublic') }}
                    </van-button>
                  </div>
                </div>
              </div>
              <div v-if="record.contentType == 'plaintext' || record.contentType == 'text'" style="font-size:0.85rem;padding:2px 0px;color: #1A1A1A;">
                <div v-if="record.msg && record.msg.trim()" v-html="record.msg"
                  style="white-space: pre-line;word-break: break-all;" class="html-content">
                </div>
              </div>
              <div v-if="record.contentType == 'mixed'" style="font-size:0.85rem;padding:2px 0px;color: #1A1A1A;">
                <div v-for="(item, index) in record.msg" :key="index">
                  <div v-if="item.type === 'plaintext' && item.content" v-html="item.content"
                    style="white-space: pre-line;word-break: break-all;" class="html-content">
                  </div>
                  <div v-if="item.type === 'img'" class="msg-image-wrapper">
                    <img :src="$common.getFullImageUrl(item.content.url, $config)" class="msg-image"
                      @click.stop="handleImageClick($common.getFullImageUrl(item.content.url, $config))" />
                  </div>
                  <div v-if="item.type === 'file'" class="msg-file-wrapper" @click="downloadFile(item.content)">
                    <van-icon name="description" size="24" color="#2A8FAD" />
                    <div class="msg-file-info">
                      <span class="msg-file-name">{{ item.content.name || $t('file') }}</span>
                      <span v-if="item.content.fileSize" class="msg-file-size">{{ formatFileSize(item.content.fileSize) }}</span>
                    </div>
                  </div>
                  <div v-if="item.type === 'video'" class="msg-video-wrapper">
                    <!-- 列表仅显示首帧缩略图，不加载视频；点击后打开全屏播放器 -->
                    <div class="msg-video-poster" @click.stop="openVideoPlayer($common.getFullImageUrl(item.content.url, $config))"
                      @touchstart.stop @touchend.stop @contextmenu.stop.prevent>
                      <img v-if="item.content.thumb" class="msg-video-thumb"
                        :src="$common.getFullImageUrl(item.content.thumb, $config)" />
                      <div v-else class="msg-video-thumb msg-video-thumb-empty"></div>
                      <div class="msg-video-play-btn">
                        <van-icon name="play" size="26" color="#ffffff" />
                      </div>
                    </div>
                  </div>
                  <div v-if="item.type === 'audio'" class="msg-audio-wrapper">
                    <div class="msg-audio-play-btn" @click.stop="toggleAudioPlay(item, record.msgId)">
                      <!-- 首次缓冲中显示转圈，缓冲完成才显示播放/暂停图标 -->
                      <div v-if="audioLoadingMsgId == record.msgId" class="msg-audio-loading"></div>
                      <van-icon v-else :name="audioPlayingMsgId == record.msgId ? 'pause' : 'play'" size="14" color="#fff" />
                    </div>
                    <div class="msg-audio-progress-track">
                      <div class="msg-audio-progress-fill" :style="{ width: getAudioProgress(record.msgId) + '%' }"></div>
                    </div>
                    <span class="msg-audio-duration">{{ getAudioDurationText(item.content.duration, record.msgId) }}</span>
                  </div>
                  <div v-if="item.type === 'emoji'" class="msg-emoji-wrapper">
                    <span class="msg-emoji" v-html="parseEmoji(item.content)"></span>
                  </div>
                  <div v-if="item.type === 'pick_location'" class="msg-location-wrapper">
                    <div :ref="'locationMap-' + record.msgId + '-' + index" class="msg-location-map"></div>
                    <div class="msg-location-info">
                      <van-icon name="location-o" size="12" />
                      <span>{{ item.content.address || item.content.lat + ',' + item.content.lng }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="font-size:0.5rem;color:#bbb;font-weight:500;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;gap: 4px;"
                class="reply-btn">
                <span>{{ $common.formatDateTime(record.createdAt) }}</span>
              </div>
              <!-- 被平台屏蔽的消息：内容保留展示，气泡底部加灰色屏蔽标记（blockReason 仅放 title 供排查，不直接展示） -->
              <div v-if="record.blocked == '1'" class="msg-blocked-row" :title="record.blockReason || ''">
                <van-icon name="warning-o" size="11" style="margin-right: 3px;position: relative;top: 0.5px;" />
                {{ $t('msg_blocked_label') }}
              </div>
            </div>
          </div>
        </template>
        <!-- 自己发送的消息：头像在右侧 -->
        <template v-else>
          <div class="message-content-wrapper" @touchstart="handleTouchStart(record, $event)" @touchend="handleTouchEnd($event)">
            <div class="msg-body msg-body-sent">
              <!-- 引用块：被引用消息已撤回时显示撤回提示 -->
              <div v-if="record.reply && record.reply.msgId" class="msg-reply-block">
                <div v-if="replyNameText(record)" class="msg-reply-name">{{ replyNameText(record) }}</div>
                <div class="msg-reply-summary">{{ replySummaryText(record) }}</div>
              </div>
              <div v-if="record.contentType == 'assistant'" style="font-size:0.85rem;padding:2px 0px;color: #1A1A1A;">
                <!-- AI 生成内容显著标识（合规要求） -->
                <span style="display: inline-block; margin-bottom: 4px; padding: 1px 5px; background: #FEF0ED; border: 0.5px solid #F8A090; border-radius: 4px; font-size: 9px; color: #8A8A8A; font-weight: 500; line-height: 1.5;">{{ $t('ai_generated_label') }}</span>
                <div v-if="record.parsedMsg && record.parsedMsg.trim()" v-html="record.parsedMsg"
                  style="white-space: pre-line;word-break: break-all;" class="html-content">
                </div>
              </div>
              <div v-if="record.contentType == 'plaintext' || record.contentType == 'text'" style="font-size:0.85rem;padding:2px 0px;color: #1A1A1A;">
                <div v-if="record.msg && record.msg.trim()" v-html="record.msg"
                  style="white-space: pre-line;word-break: break-all;" class="html-content">
                </div>
              </div>
              <div v-if="record.contentType == 'mixed'" style="font-size:0.85rem;padding:2px 0px;color: #1A1A1A;">
                <div v-for="(item, index) in record.msg" :key="index">
                  <div v-if="item.type === 'plaintext' && item.content" v-html="item.content"
                    style="white-space: pre-line;word-break: break-all;" class="html-content">
                  </div>
                  <div v-if="item.type === 'img'" class="msg-image-wrapper">
                    <img :src="$common.getFullImageUrl(item.content.url, $config)" class="msg-image"
                      @click.stop="handleImageClick($common.getFullImageUrl(item.content.url, $config))" />
                  </div>
                  <div v-if="item.type === 'file'" class="msg-file-wrapper" @click="downloadFile(item.content)">
                    <van-icon name="description" size="24" color="#2A8FAD" />
                    <div class="msg-file-info">
                      <span class="msg-file-name">{{ item.content.name || $t('file') }}</span>
                      <span v-if="item.content.fileSize" class="msg-file-size">{{ formatFileSize(item.content.fileSize) }}</span>
                    </div>
                  </div>
                  <div v-if="item.type === 'video'" class="msg-video-wrapper">
                    <!-- 列表仅显示首帧缩略图，不加载视频；点击后打开全屏播放器 -->
                    <div class="msg-video-poster" @click.stop="openVideoPlayer($common.getFullImageUrl(item.content.url, $config))"
                      @touchstart.stop @touchend.stop @contextmenu.stop.prevent>
                      <img v-if="item.content.thumb" class="msg-video-thumb"
                        :src="$common.getFullImageUrl(item.content.thumb, $config)" />
                      <div v-else class="msg-video-thumb msg-video-thumb-empty"></div>
                      <div class="msg-video-play-btn">
                        <van-icon name="play" size="26" color="#ffffff" />
                      </div>
                    </div>
                  </div>
                  <div v-if="item.type === 'audio'" class="msg-audio-wrapper">
                    <div class="msg-audio-play-btn" @click.stop="toggleAudioPlay(item, record.msgId)">
                      <!-- 首次缓冲中显示转圈，缓冲完成才显示播放/暂停图标 -->
                      <div v-if="audioLoadingMsgId == record.msgId" class="msg-audio-loading"></div>
                      <van-icon v-else :name="audioPlayingMsgId == record.msgId ? 'pause' : 'play'" size="14" color="#fff" />
                    </div>
                    <div class="msg-audio-progress-track">
                      <div class="msg-audio-progress-fill" :style="{ width: getAudioProgress(record.msgId) + '%' }"></div>
                    </div>
                    <span class="msg-audio-duration">{{ getAudioDurationText(item.content.duration, record.msgId) }}</span>
                  </div>
                  <div v-if="item.type === 'emoji'" class="msg-emoji-wrapper">
                    <span class="msg-emoji" v-html="parseEmoji(item.content)"></span>
                  </div>
                  <div v-if="item.type === 'pick_location'" class="msg-location-wrapper">
                    <div :ref="'locationMap-' + record.msgId + '-' + index" class="msg-location-map"></div>
                    <div class="msg-location-info">
                      <van-icon name="location-o" size="12" />
                      <span>{{ item.content.address || item.content.lat + ',' + item.content.lng }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="font-size:0.5rem;color:#bbb;font-weight:500;display: flex;align-items: center;justify-content: flex-end;flex-wrap: wrap;gap: 4px;"
                class="reply-btn">
                <!-- 消息状态显示 -->
                <template v-if="record.toUserId != platformUserId && record.direction == '0'">
                  <template v-if="record.sendStatus === 'blocked'">
                    <span v-if="record.errorMessage" style="color: #E8543A; font-size: 0.45rem; margin-right: 4px;">
                      {{ record.errorMessage }}
                    </span>
                    <span style="color: #E8543A; display: flex; align-items: center;">
                      <van-icon name="warning-o" size="12" style="margin-right: 2px;" />
                      {{ $t('msg_blocked') }}
                    </span>
                  </template>
                  <template v-else-if="record.sendStatus === 'failed'">
                    <span v-if="record.errorMessage" style="color: #E05252; font-size: 0.45rem; margin-right: 4px;">
                      {{ record.errorMessage }}
                    </span>
                    <span @click="retrySendMessage(record)"
                      style="color: #E05252; cursor: pointer; display: flex; align-items: center;">
                      <van-icon name="replay" size="12" style="margin-right: 2px;" />
                      {{ $t('retry') }}
                    </span>
                  </template>
                  <span v-else-if="record.read == '1'">{{ $t('msg_read') }}</span>
                  <template v-else>
                    <span v-if="record.serverReceived == '1'">{{ $t('msg_sent') }}</span>
                    <span v-if="record.read != '1'">{{ $t('msg_unread') }}</span>
                  </template>
                </template>
                <span>{{ $common.formatDateTime(record.createdAt) }}</span>
              </div>
              <!-- 被平台屏蔽的消息：内容保留展示，气泡底部加灰色屏蔽标记（blockReason 仅放 title 供排查，不直接展示） -->
              <div v-if="record.blocked == '1'" class="msg-blocked-row" :title="record.blockReason || ''">
                <van-icon name="warning-o" size="11" style="margin-right: 3px;position: relative;top: 0.5px;" />
                {{ $t('msg_blocked_label') }}
              </div>
            </div>
          </div>
          <div class="message-avatar">
            <img v-if="currentAvatarUrl" :src="$common.getFullImageUrl(currentAvatarUrl, $config, 's')" class="avatar-img" />
            <div v-else class="avatar-placeholder avatar-placeholder-self">{{ (currentUserName || $t('anonymous'))[0]
            }}</div>
          </div>
        </template>
      </div>
      <div style="clear:both;"></div>
    </div>
    <!-- 语音消息播放器（隐藏，仅用于控制播放；必须在 v-for 外，否则 $refs 收集为数组） -->
    <audio ref="audioPlayer" @ended="onAudioEnded" @timeupdate="onAudioTimeUpdate" @loadedmetadata="onAudioLoadedMetadata" @playing="onAudioPlaying" @error="onAudioError" style="display:none;"></audio>

    <!-- 视频全屏播放器（点击视频消息打开，v-if 惰性渲染，打开才下载） -->
    <div v-if="videoPlayerUrl" class="video-player-overlay" @click.self="closeVideoPlayer">
      <van-icon name="cross" class="video-player-close" size="26" color="#ffffff" @click="closeVideoPlayer" />
      <video class="video-player-video" :src="videoPlayerUrl" controls autoplay playsinline webkit-playsinline
        x5-playsinline @contextmenu.stop.prevent></video>
    </div>

    <!-- 地理位置选择器弹窗 -->
    <van-popup v-model="showLocationPicker" round position="bottom" :style="{ height: '70vh' }"
      @opened="onLocationPickerOpened">
      <div style="display: flex; flex-direction: column; height: 100%;">
        <div
          style="padding: 16px; border: 1px solid #E0DDD8; display: flex; justify-content: space-between; align-items: center;">
          <div style="font-weight: bold; font-size: 16px;">{{ locationPickerDescription }}</div>
          <van-icon name="cross" size="20" color="#666" @click="closeLocationPicker" />
        </div>
        <div style="flex: 1; padding: 10px;">
          <MapLocationPicker ref="mapLocationPicker" width="100%" height="100%" :auto-get-location="true"
            @location-selected="onLocationSelected" />
        </div>
      </div>
    </van-popup>

    <!-- 日期时间选择器弹窗 -->
    <van-popup v-model="showDateTimePicker" round position="bottom" @opened="onDateTimePickerOpened">
      <div style="padding: 16px;">
        <div style="font-weight: bold; font-size: 16px; margin-bottom: 16px;">{{ dateTimePickerDescription }}</div>
        <div style="margin-bottom: 12px;">
          <label style="display: block; margin-bottom: 6px; font-size: 14px; color: #8A8A8A;">{{ $t('label_start_datetime') }}</label>
          <input ref="startDateTimeInput" type="datetime-local" v-model="startDateTimeStr"
            @change="onStartDateTimeChange" @click="onDateTimeInputClick($refs.startDateTimeInput)"
            style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; cursor: pointer;" />
        </div>
        <div style="margin-bottom: 16px;">
          <label style="display: block; margin-bottom: 6px; font-size: 14px; color: #8A8A8A;">{{ $t('label_end_datetime') }}</label>
          <input ref="endDateTimeInput" type="datetime-local" v-model="endDateTimeStr"
            @click="onDateTimeInputClick($refs.endDateTimeInput)"
            style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; cursor: pointer;" />
        </div>
        <div style="display: flex; gap: 10px;">
          <van-button type="default" size="large" @click="onDateTimeCancel">{{ $t('cancel') }}</van-button>
          <van-button type="primary" size="large" @click="onDateTimeConfirm">{{ $t('confirm') }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 消息操作菜单 -->
    <van-action-sheet
      v-model="showActionMenu"
      :actions="actionMenuItems"
      :cancel-text="$t('cancel')"
      close-on-click-action
      @select="onActionMenuSelect"
    />

    <!-- 举报对话框 -->
    <ReportDialog ref="reportDialog" />

  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import { Icon, ImagePreview, Toast, Popup, Button, ActionSheet } from 'vant'
import wsService from '@/services/websocket.js'

Vue.use(Icon)
Vue.use(ImagePreview)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Button)
Vue.use(ActionSheet)

import twemoji from 'twemoji'
import MapLocationPicker from './MapLocationPicker.vue'
import ReportDialog from './ReportDialog.vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  components: {
    MapLocationPicker,
    ReportDialog
  },
  name: 'ChatMsgList',
  props: {
    // 平台用户ID
    platformUserId: {
      type: String,
      default: '20210802'
    },
    // 会话ID
    chatSessionId: {
      type: String,
      default: ''
    },
    // 接收方用户ID
    toUserId: {
      type: String,
      default: ''
    },
    // 发送方用户ID（可选，用于指定查询特定用户的聊天记录）
    fromUserId: {
      type: String,
      default: ''
    },
    // 每页加载消息数量
    pageSize: {
      type: Number,
      default: 30
    },
    // 排序方式：'desc' 倒序（最新在前，默认），'asc' 正序（最早在前）
    order: {
      type: String,
      default: 'desc'
    },
    // 最大高度（可选，用于限制聊天列表高度）
    maxHeight: {
      type: String,
      default: ''
    },
    // 最小高度（可选，用于设置聊天列表最小高度）
    minHeight: {
      type: String,
      default: ''
    },
    // 是否过滤思考内容，1=过滤
    filterThink: {
      type: Number,
      default: 0
    },
    // 头像相关参数
    currentAvatarUrl: {
      type: String,
      default: ''
    },
    currentUserName: {
      type: String,
      default: ''
    },
    targetAvatarUrl: {
      type: String,
      default: ''
    },
    targetUserName: {
      type: String,
      default: ''
    },
    // 当前用户ID（用于举报功能）
    currentUserId: {
      type: String,
      default: ''
    },
    // 是否是用户私聊（用于控制举报/屏蔽功能）
    isUserChat: {
      type: Boolean,
      default: false
    },
    // 是否允许未登录用户查看（用于 discover 等公开内容）
    allowGuest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chat: {
        loading: false,
        finished: true,
        refreshing: false,
        curPage: 1,
        pageSize: this.pageSize,
        chatMsgs: [],
        errorMsg: '', // 错误信息（如私有会话提示）
      },
      forceVueUpdate: false,
      deprecateHandleChatScroll: false,
      // requirementClarified: '0',
      // public: '0',
      // 地理位置选择相关
      showLocationPicker: false,
      locationPickerDescription: '',
      activeActionMsgId: null,
      // 只读位置地图实例存储
      locationMaps: {},
      // think内容展开状态管理
      thinkExpanded: {},
      // 日期时间选择相关
      showDateTimePicker: false,
      startDateTimeStr: '',
      endDateTimeStr: '',
      dateTimePickerDescription: '',
      // 举报相关
      showActionMenu: false,
      actionMenuItems: [],
      selectedMsg: null,
      touchTimer: null,
      // 语音消息播放状态
      audioPlayingMsgId: null,
      audioLoadingMsgId: null, // 语音缓冲中（首次点击）
      audioCurrentTime: 0,
      audioDuration: 0,
      // 视频全屏播放器
      videoPlayerUrl: '', // 当前播放的视频 URL（为空表示关闭）
    }
  },
  computed: {
    // 地图位置功能开关：cn 版暂时关闭（底图瓦片供应商合规问题）
    mapFeatureEnabled() {
      return !(this.$config && this.$config.region === 'cn')
    }
  },
  mounted() {
    // 如果初始就有 chatSessionId 或 toUserId，主动加载消息
    // 因为 watch 只在值变化时触发，初始值不会触发
    if (this.chatSessionId) {
      this.refresh()
    } else if (this.toUserId) {
      // AI聊天场景（toUserId是平台用户）必须有chatSessionId才能加载消息
      // 避免在获取last session之前就加载所有消息
      const platformUserId = this.platformUserId || '20210802'
      if (this.toUserId === platformUserId) {
        // AI聊天场景：必须有chatSessionId才能加载
        return
      }
      // 私聊场景：可以没有chatSessionId，通过toUserId加载
      this.refresh()
    }
  },
  watch: {
    // 监听toUserId变化
    toUserId(newVal, oldVal) {
      if (newVal) {
        // AI聊天场景（toUserId是平台用户）必须有chatSessionId才能加载消息
        const platformUserId = this.platformUserId || '20210802'
        if (newVal === platformUserId && !this.chatSessionId) {
          console.log('[ChatMsgList] watch toUserId - AI chat scene, waiting for chatSessionId...')
          return
        }
        this.refresh()
      }
    },
    // 监听chatSessionId变化
    chatSessionId(newVal) {
      if (newVal) {
        this.refresh()
      }
    },
  },
  beforeDestroy() {
    // 清理语音播放器
    const player = this.getAudioPlayerEl()
    if (player) {
      player.pause()
      player.src = ''
    }
    // 关闭位置选择器弹窗，防止组件销毁后用户还能选择位置
    this.showLocationPicker = false
    // 关闭日期时间选择器弹窗
    this.showDateTimePicker = false
    this.activeActionMsgId = null
    this.startDateTimeStr = ''
    this.endDateTimeStr = ''
    // 清理所有位置地图实例
    this.cleanupLocationMaps()
  },
  methods: {
    // 点击对方消息头像（私聊中由父组件打开对方 profile）
    onAvatarClick(record) {
      if (record.fromUserId == this.platformUserId) return
      this.$emit('avatar-click', record.fromUserId)
    },
    // 清理资源
    cleanup() {
      // 不涉及 socket，仅清理定时器等
    },
    // 解析原始内容（emoji等）
    parseRawContent(content) {
      // 先反转义 HTML 实体（如 &lt; &gt; &amp;）
      if (content && (content.includes('&lt;') || content.includes('&gt;') || content.includes('&amp;'))) {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = content
        content = tempDiv.textContent
      }
      return twemoji.parse(content, {
        className: 'twemoji',
        base: this.$publicPath + 'static/twemoji/',
        size: 'svg',
        ext: '.svg'
      })
    },
    // 解析 think 标签和 actions（支持 invisible 标签）
    parseThinkTags(content) {
      if (!content || typeof content !== 'string') {
        return { text: content, thinkContent: null, isThinking: false, actions: null }
      }

      let invisibleContent = ''
      let visibleText = ''
      let thinkContents = []
      let hasIncompleteThink = false

      // Step 1: 找到所有完整的 think 标签位置
      const thinkTagRegex = /<\s*think\s*>([\s\S]*?)<\s*\/\s*think\s*>/g
      const thinkMatches = []
      let match
      while ((match = thinkTagRegex.exec(content)) !== null) {
        thinkMatches.push({
          fullMatch: match[0],
          content: match[1],
          startIndex: match.index,
          endIndex: match.index + match[0].length
        })
      }

      // Step 2: 先构建临时文本（移除 think 标签），然后在 tempText 上查找 invisible
      // 这是为了确保只处理 think 外部的 invisible 标签
      let tempTextForInvisible = content
      for (const tm of thinkMatches) {
        tempTextForInvisible = tempTextForInvisible.replace(tm.fullMatch, '')
      }
      // 移除不完整的 think 标签
      tempTextForInvisible = tempTextForInvisible.replace(/<\s*think\s*>[\s\S]*$/, '')

      // 在移除 think 后的文本上查找 invisible 标签
      const invisibleStartMatch = tempTextForInvisible.match(/<\s*invisible\s*>/i)
      const invisibleEndMatch = tempTextForInvisible.match(/<\s*\/\s*invisible\s*>/i)
      let invisibleStart = invisibleStartMatch ? invisibleStartMatch.index : -1
      let invisibleEnd = invisibleEndMatch ? invisibleEndMatch.index + invisibleEndMatch[0].length : -1

      // Step 3: 提取 invisible 内容（从 tempTextForInvisible 中）
      if (invisibleStart !== -1 && invisibleEnd !== -1) {
        // 找到完整的 <invisible>...</invisible>
        const invisibleStartTagEnd = tempTextForInvisible.indexOf('>', invisibleStart) + 1
        invisibleContent = tempTextForInvisible.substring(invisibleStartTagEnd, invisibleEndMatch.index)
      }

      // Step 4: 处理完整的 think 标签
      // 检查是否有 invisible 标签在 think 标签内部（用于清理 thinkContent）
      for (const tm of thinkMatches) {
        let thinkContent = tm.content
        // 移除 think 内所有完整的 invisible 块
        thinkContent = thinkContent.replace(/<\s*invisible\s*>[\s\S]*?<\s*\/\s*invisible\s*>/gi, '').trim()
        // 再处理不完整的 invisible（只有开始标签）
        const localInvisibleStartMatch = thinkContent.match(/<\s*invisible\s*>/i)
        if (localInvisibleStartMatch) {
          thinkContent = thinkContent.substring(0, localInvisibleStartMatch.index).trim()
        }
        thinkContents.push(thinkContent)
      }

      // Step 5: 检查不完整的 think 标签（流式传输中）
      const incompleteThinkMatch = content.match(/<\s*think\s*>([\s\S]*)$/)
      if (incompleteThinkMatch && thinkMatches.length === 0) {
        let thinkPart = incompleteThinkMatch[1]
        // 检查是否有闭合的 </think>
        const closeThinkMatch = thinkPart.match(/<\s*\/\s*think\s*>/i)

        if (closeThinkMatch) {
          // think 有闭合标签，已完成
          thinkPart = thinkPart.substring(0, closeThinkMatch.index).trim()
          // 先移除 think 内部所有完整的 invisible 块
          thinkPart = thinkPart.replace(/<\s*invisible\s*>[\s\S]*?<\s*\/\s*invisible\s*>/gi, '').trim()
          // 再处理不完整的 invisible（只有开始标签）
          const incompleteInvisibleMatch = thinkPart.match(/<\s*invisible\s*>/i)
          if (incompleteInvisibleMatch) {
            thinkPart = thinkPart.substring(0, incompleteInvisibleMatch.index).trim()
          }
          hasIncompleteThink = false
        } else {
          // 还在流式传输中，不过滤 invisible，全部展示以感知内容在增长
          hasIncompleteThink = true
        }
        if (thinkPart) {
          thinkContents.push(thinkPart)
        }
      }

      // Step 6: 构建可见文本
      // 使用之前准备的 tempTextForInvisible（已经移除了 think 标签）
      let tempText = tempTextForInvisible

      // 移除 invisible 标签及其内容
      if (invisibleStart !== -1) {
        if (invisibleEnd !== -1) {
          // 完整的 invisible 标签 - 使用正则匹配和移除
          const invisibleRegex = /<\s*invisible\s*>[\s\S]*?<\s*\/\s*invisible\s*>/i
          tempText = tempText.replace(invisibleRegex, '')
        } else {
          // 只有开始标签（流式传输中）- 查找 invisible 开始标签并截断
          const tempInvisibleMatch = tempText.match(/<\s*invisible\s*>/i)
          if (tempInvisibleMatch) {
            tempText = tempText.substring(0, tempInvisibleMatch.index)
          }
        }
      }

      visibleText = tempText.replace(/\n{3,}/g, '\n\n').trim()

      // Step 7: 解析 actions、completeness、estimated_remaining_rounds、requirementDetail、summary
      let actions = null
      let completeness = null
      let estimatedRemainingRounds = null
      let requirementDetail = null
      let summary = null
      if (!hasIncompleteThink && invisibleContent) {
        const actionsRegex = /<actions>\s*([\s\S]*?)\s*<\/actions>/
        const actionsMatch = invisibleContent.match(actionsRegex)
        if (actionsMatch) {
          try {
            // 容错：AI 可能输出 {{ / }} (双花括号)，替换为标准 JSON 单花括号
            const actionsStr = actionsMatch[1].replace(/\{\{/g, '{').replace(/\}\}/g, '}')
            actions = JSON.parse(actionsStr)
          } catch (e) {
            console.error('Failed to parse actions:', e)
          }
        }

        // Parse completeness
        const completenessRegex = /<completeness>\s*(\d+)\s*<\/completeness>/
        const completenessMatch = invisibleContent.match(completenessRegex)
        if (completenessMatch) {
          const val = parseInt(completenessMatch[1], 10)
          if (!isNaN(val)) {
            completeness = Math.max(0, Math.min(100, val))
          }
        }

        // Parse estimated_remaining_rounds
        const remainingRegex = /<estimated_remaining_rounds>\s*(\d+)\s*<\/estimated_remaining_rounds>/
        const remainingMatch = invisibleContent.match(remainingRegex)
        if (remainingMatch) {
          const val = parseInt(remainingMatch[1], 10)
          if (!isNaN(val)) {
            estimatedRemainingRounds = val
          }
        }

        // Parse requirement_detail
        const detailRegex = /<requirement_detail>\s*([\s\S]*?)\s*<\/requirement_detail>/
        const detailMatch = invisibleContent.match(detailRegex)
        if (detailMatch) {
          requirementDetail = detailMatch[1].trim()
          if (requirementDetail === '') requirementDetail = null
        }

        // Parse summary
        const summaryRegex = /<summary>\s*([\s\S]*?)\s*<\/summary>/
        const summaryMatch = invisibleContent.match(summaryRegex)
        if (summaryMatch) {
          summary = summaryMatch[1].trim()
          if (summary === '') summary = null
        }
      }

      // Parse user_msg_options（AI 建议的用户消息选项，JSON 数组字符串；对齐 client/ chat_message.parseThinkTags）
      let userMsgOptions = null
      if (!hasIncompleteThink && invisibleContent) {
        const userMsgOptionsRegex = /<user_msg_options>\s*([\s\S]*?)\s*<\/user_msg_options>/
        const userMsgOptionsMatch = invisibleContent.match(userMsgOptionsRegex)
        if (userMsgOptionsMatch) {
          userMsgOptions = userMsgOptionsMatch[1].trim()
          if (userMsgOptions === '') userMsgOptions = null
        }
      }

      return {
        text: visibleText,
        thinkContent: thinkContents.length > 0 ? thinkContents.join('\n') : null,
        isThinking: hasIncompleteThink,
        actions: actions,
        completeness: completeness,
        estimatedRemainingRounds: estimatedRemainingRounds,
        requirementDetail: requirementDetail,
        summary: summary,
        userMsgOptions: userMsgOptions
      }
    },
    // 对齐 client/ ai_chat_page：session meta 没有返回 userMsgOptions 时，从最后一条 AI 消息的
    // 隐形标签兜底解析。按消息时间从新到旧找第一条带 userMsgOptions 的 assistant 消息并 emit，
    // ChatBox 侧仅在尚未有选项时接收（session meta / WS 字段优先）
    emitLatestUserMsgOptions() {
      const msgs = this.chat.chatMsgs || []
      if (msgs.length === 0) return
      // DESC（默认）index 0 = 最新；ASC 末尾 = 最新
      const step = this.order === 'asc' ? -1 : 1
      const start = this.order === 'asc' ? msgs.length - 1 : 0
      for (let i = start; i >= 0 && i < msgs.length; i += step) {
        const m = msgs[i]
        if (m.contentType !== 'assistant' || !m.userMsgOptions) continue
        try {
          const opts = JSON.parse(String(m.userMsgOptions))
          if (Array.isArray(opts) && opts.length > 0) {
            this.$emit('user-msg-options', opts.filter(function(e) { return typeof e === 'string' }))
          }
        } catch (e) { /* ignore */ }
        return
      }
    },
    // 切换 think 内容展开状态
    toggleThinkExpanded(msgId) {
      this.$set(this.thinkExpanded, msgId, !this.thinkExpanded[msgId])
    },
    // 滚动 think 框到底部
    scrollThinkBoxToBottom(msgId) {
      this.$nextTick(() => {
        const thinkBoxRef = this.$refs['thinkBox-' + msgId]
        if (thinkBoxRef) {
          const thinkBox = Array.isArray(thinkBoxRef) ? thinkBoxRef[0] : thinkBoxRef
          if (thinkBox) {
            thinkBox.scrollTop = thinkBox.scrollHeight
          }
        }
      })
    },
    // 解析消息中的 actions 标签
    parseActions(content) {
      if (!content || typeof content !== 'string') {
        return { text: content, actions: null }
      }
      const actionsRegex = /<actions>\s*([\s\S]*?)\s*<\/actions>/
      const match = content.match(actionsRegex)
      if (match) {
        try {
          // 容错：AI 可能输出 {{ / }} (双花括号)，替换为标准 JSON 单花括号
          const actionsStr = match[1].replace(/\{\{/g, '{').replace(/\}\}/g, '}')
          const actions = JSON.parse(actionsStr)
          const text = content.replace(actionsRegex, '').trim()
          return { text, actions }
        } catch (e) {
          console.error('Failed to parse actions:', e)
          return { text: content, actions: null }
        }
      }
      return { text: content, actions: null }
    },
    // 检查 actions 是否包含 requirement_clarified
    hasRequirementClarified(actions) {
      return Array.isArray(actions) && actions.some(
        action => action.type === 'requirement_clarified'
      )
    },
    // 检查消息列表中是否有需求已明确的消息
    checkRequirementClarified() {
      const hasClarified = this.chat.chatMsgs.some(msg =>
        msg.contentType === 'assistant' &&
        this.hasRequirementClarified(msg.actions)
      )
      if (hasClarified) {
        this.$emit('requirement-clarified')
      }
      return hasClarified
    },
    // 从历史消息中恢复进度状态（取最新一条带进度信息的 AI 消息）
    restoreProgressFromHistory() {
      // DESC + column-reverse: index 0 = 最新消息
      for (let i = 0; i < this.chat.chatMsgs.length; i++) {
        const msg = this.chat.chatMsgs[i]
        if (msg.contentType === 'assistant') {
          if (msg.completeness != null || msg.estimatedRemainingRounds != null) {
            this.$emit('progress-update', {
              completeness: msg.completeness,
              estimatedRemainingRounds: msg.estimatedRemainingRounds
            })
            break
          }
        }
      }
    },
    // 从历史消息中提取用户第一条实质性消息（兜底 userMsg，与 client 端 ai_chat_page 逻辑一致）
    // DESC 排序时 index 0 = 最新消息；ASC 时 index 0 = 最早消息
    extractFirstUserMsgFromHistory() {
      const msgs = this.chat.chatMsgs
      if (!msgs || msgs.length === 0) return
      let firstText = ''
      let firstImages = []
      // 遍历顺序：DESC（默认）从最早消息开始找（末尾向前），ASC 从开头开始
      const startIndex = this.order === 'asc' ? 0 : msgs.length - 1
      const step = this.order === 'asc' ? 1 : -1
      // 文本/图片独立扫描是故意设计：图片取"第一条带图的"（哪怕它是后续消息），
      // 也要并入 userMsg，不依赖首条消息是否带多媒体；文本和图片都找到才停
      for (let i = startIndex; i >= 0 && i < msgs.length; i += step) {
        const msg = msgs[i]
        if (msg.direction !== '0') continue
        // 提取文本（非空即算实质性消息）
        if (!firstText) {
          if ((msg.contentType === 'plaintext' || msg.contentType === 'text') && msg.msg && msg.msg.trim()) {
            firstText = msg.msg.trim()
          } else if (msg.contentType === 'mixed' && Array.isArray(msg.msg)) {
            for (let j = 0; j < msg.msg.length; j++) {
              const item = msg.msg[j]
              if (item.type === 'plaintext' && item.content && item.content.toString().trim()) {
                firstText = item.content.toString().trim()
                break
              }
            }
          }
        }
        // 提取图片
        if (firstImages.length === 0 && msg.contentType === 'mixed' && Array.isArray(msg.msg)) {
          for (let k = 0; k < msg.msg.length; k++) {
            const item = msg.msg[k]
            if (item.type === 'img') {
              let rawUrl = ''
              const c = item.content
              if (c && typeof c === 'object') {
                rawUrl = c.url || ''
              } else if (c) {
                rawUrl = c.toString()
              }
              if (rawUrl) {
                firstImages.push(rawUrl)
              }
            }
          }
        }
        if (firstText && firstImages.length > 0) break
      }
      if (firstText || firstImages.length > 0) {
        this.$emit('first-user-msg-extracted', {
          text: firstText,
          images: firstImages
        })
      }
    },
    // 处理地理位置选择
    handlePickLocation(action, msgId) {
      this.locationPickerDescription = action.description || this.$t('chat_selectLocationOnMap')
      this.activeActionMsgId = msgId
      this.showLocationPicker = true
    },
    // 用户选择位置后的回调
    onLocationSelected(location) {
      this.showLocationPicker = false
      if (location && this.activeActionMsgId) {
        // 将位置信息通过事件传递给父组件
        this.$emit('location-selected', {
          location: location,
          msgId: this.activeActionMsgId
        })
      }
      this.activeActionMsgId = null
    },
    // 关闭位置选择器
    closeLocationPicker() {
      this.showLocationPicker = false
      this.activeActionMsgId = null
    },
    // ============ 日期选择相关方法（支持日期时间选择，精确到分钟） ============
    // 处理日期时间选择 - 可选择单日期时间或范围日期时间
    handlePickDate(action, msgId) {
      console.log('handlePickDate called', action, msgId)
      this.activeActionMsgId = msgId
      this.dateTimePickerDescription = action.description || this.$t('select_date')
      const now = this.formatDateTimeInput(new Date())
      this.startDateTimeStr = now
      this.endDateTimeStr = now
      this.showDateTimePicker = true
    },
    // 日期时间选择器弹窗打开后的回调
    onDateTimePickerOpened() {
      // 延迟调用 showPicker，等弹窗完全稳定后再弹出第一个时间选择器
      setTimeout(() => {
        const input = this.$refs.startDateTimeInput
        if (input) {
          try {
            input.showPicker && input.showPicker()
          } catch (e) {
            console.log('showPicker failed:', e)
          }
        }
      }, 300) // 延迟 300ms
    },
    // 点击日期时间输入框时弹出选择器
    onDateTimeInputClick(inputElement) {
      if (inputElement && inputElement.showPicker) {
        try {
          inputElement.showPicker()
        } catch (e) {
          console.log('showPicker failed:', e)
        }
      }
    },
    // 开始日期时间变化时，自动设置结束日期时间
    onStartDateTimeChange() {
      this.endDateTimeStr = this.startDateTimeStr
    },
    // 用户确认日期时间选择
    onDateTimeConfirm() {
      if (!this.startDateTimeStr) {
        Toast(this.$t('toast_select_start_datetime'))
        return
      }

      const startDate = this.startDateTimeStr
      const endDate = this.endDateTimeStr

      // 确保结束日期时间不早于开始日期时间
      if (new Date(endDate) < new Date(startDate)) {
        Toast(this.$t('toast_end_before_start'))
        return
      }

      this.showDateTimePicker = false

      // 将T格式转换为空格格式（用于输出）
      const startDateDisplay = startDate.replace('T', ' ')
      const endDateDisplay = endDate.replace('T', ' ')

      if (startDate === endDate) {
        // 两个日期时间相同，当作单个日期时间
        this.$emit('date-selected', {
          date: startDateDisplay,
          dateObj: new Date(startDate),
          type: 'pick_date',
          msgId: this.activeActionMsgId
        })
      } else {
        // 两个日期时间不同，当作日期时间范围
        this.$emit('date-selected', {
          startDate: startDateDisplay,
          endDate: endDateDisplay,
          startDateObj: new Date(startDate),
          endDateObj: new Date(endDate),
          type: 'pick_date_range',
          msgId: this.activeActionMsgId
        })
      }

      this.activeActionMsgId = null
    },
    // 用户取消日期时间选择
    onDateTimeCancel() {
      console.log('Date-time picker cancelled')
      this.showDateTimePicker = false
      this.activeActionMsgId = null
    },
    // 格式化日期时间为字符串（供显示使用）YYYY-MM-DD HH:mm
    formatDateTimeDisplay(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    // 格式化日期时间为字符串（供input的value使用）YYYY-MM-DDTHH:mm
    formatDateTimeInput(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    },
    // 格式化日期为字符串 YYYY-MM-DD（保留原有方法以防其他地方使用）
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // ============ 日期选择相关方法结束 ============
    // 弹窗打开后的回调，触发获取当前位置
    onLocationPickerOpened() {
      this.$nextTick(() => {
        if (this.$refs.mapLocationPicker) {
          // 强制初始化地图（解决弹窗中地图不渲染问题）
          this.$refs.mapLocationPicker.forceInitMap()
          // 延迟一点再获取位置，确保地图已就绪
          setTimeout(() => {
            if (this.$refs.mapLocationPicker) {
              this.$refs.mapLocationPicker.getUserLocation()
            }
          }, 500)
        }
      })
    },
    // 初始化消息中的只读位置地图
    initLocationMaps() {
      this.$nextTick(() => {
        this.chat.chatMsgs.forEach(record => {
          if (record.contentType === 'mixed' && Array.isArray(record.msg)) {
            record.msg.forEach((item, index) => {
              if (item.type === 'pick_location' && item.content) {
                const mapKey = `${record.msgId}-${index}`
                const refName = `locationMap-${record.msgId}-${index}`
                this.initReadonlyLocationMap(refName, item.content, mapKey)
              }
            })
          }
        })
      })
    },
    // 初始化单个只读位置地图
    initReadonlyLocationMap(refName, locationData, mapKey) {
      // 如果地图已存在，先销毁
      if (this.locationMaps[mapKey]) {
        this.locationMaps[mapKey].remove()
        delete this.locationMaps[mapKey]
      }

      // 获取地图容器元素
      const mapElements = this.$refs[refName]
      const mapContainer = Array.isArray(mapElements) ? mapElements[0] : mapElements

      if (!mapContainer) {
        console.warn('Map container not found:', refName)
        return
      }

      // 等待容器有尺寸后再初始化
      setTimeout(() => {
        try {
          const lat = parseFloat(locationData.lat)
          const lng = parseFloat(locationData.lng)

          // 创建只读地图（禁用点击交互）
          const map = L.map(mapContainer, {
            center: [lat, lng],
            zoom: 15,
            zoomControl: true,
            attributionControl: false,
            // 禁用点击和双击交互（只读模式）
            dragging: true, // 允许拖拽移动地图
            touchZoom: true, // 允许触摸缩放
            scrollWheelZoom: true, // 允许滚轮缩放
            doubleClickZoom: true, // 允许双击缩放
            boxZoom: true, // 允许框选缩放
          })

          // 添加 CartoDB Positron 图层（无需 API Key，支持全球访问）
          L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 19,
            subdomains: 'bcd'
          }).addTo(map)

          // 创建自定义标记（使用 divIcon 避免引用本地图片）
          const locationIcon = L.divIcon({
            className: 'location-marker',
            html: '<div style="background-color: #E8543A; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 5px rgba(0,0,0,0.3);"></div>',
            iconSize: [20, 20],
            iconAnchor: [10, 10]
          })

          // 添加位置标记
          const marker = L.marker([lat, lng], { icon: locationIcon }).addTo(map)

          // 如果有地址信息，显示在弹出框中
          if (locationData.address) {
            marker.bindPopup(locationData.address).openPopup()
          }

          // 存储地图实例
          this.$set(this.locationMaps, mapKey, map)
        } catch (error) {
          console.error('Failed to initialize location map:', error)
        }
      }, 100)
    },
    // 清理所有位置地图实例
    cleanupLocationMaps() {
      Object.keys(this.locationMaps).forEach(key => {
        if (this.locationMaps[key]) {
          this.locationMaps[key].remove()
        }
      })
      this.locationMaps = {}
    },
    // 定位到指定消息（搜索结果跳转用）：自动加载更早的历史直到该消息进入列表，然后滚动过去并高亮
    async locateMessage(msgId) {
      if (!msgId) return
      // 逐页加载历史直到找到（loadChatMessages 有 loading/finished 守卫，不会重复请求）
      let guard = 0
      while (guard < 100) {
        guard++
        const idx = this.chat.chatMsgs.findIndex(m => String(m.msgId) === String(msgId))
        if (idx >= 0) break
        if (this.chat.finished) break
        if (this.chat.loading) {
          await new Promise(resolve => setTimeout(resolve, 200))
          continue
        }
        await this.loadChatMessages()
      }
      await this.$nextTick()
      const container = this.$refs.infiniteChatScrollContainer
      if (!container) return
      const el = container.querySelector('[data-msg-id="' + msgId + '"]')
      if (!el) return
      el.scrollIntoView({ block: 'center' })
      el.classList.add('msg-locate-highlight')
      setTimeout(() => {
        el.classList.remove('msg-locate-highlight')
      }, 2500)
    },
    // 刷新聊天（外部调用）
    refresh() {
      this.chat.chatMsgs = []
      this.chat.errorMsg = ''
      this.chat.curPage = 1
      this.chat.finished = false
      this.loadChatMessages()
      // this.loadChatSession()
    },
    // 加载聊天消息（内部使用）
    async loadChatMessages() {
      let vm = this
      if (vm.chat.finished || vm.chat.loading) {
        return
      }
      
      // 安全检查：必须登录才能加载历史聊天记录（除非明确允许未登录访问，如 discover）
      // 未登录用户只能查看当前新会话的消息（通过 WebSocket 实时接收）
      if (!vm.$store.state.alreadyLogin && !vm.allowGuest) {
        console.log('[DEBUG] ChatMsgList loadChatMessages - 未登录，不加载历史消息')
        vm.chat.loading = false
        vm.chat.finished = true
        return
      }
      
      // 安全检查：必须有 chatSessionId 或 toUserId 才能加载消息
      // - chatSessionId: AI聊天场景
      // - toUserId: 私聊场景（不传 chatSessionId）
      if ((!vm.chatSessionId || vm.chatSessionId === '') && (!vm.toUserId || vm.toUserId === '')) {
        console.log('[DEBUG] ChatMsgList loadChatMessages - 缺少 chatSessionId 和 toUserId，不加载消息')
        vm.chat.loading = false
        vm.chat.finished = true
        return
      }

      vm.chat.loading = true
      var url = '/api/chat/get_chat_msgs'
      var req = {
        curPage: vm.chat.curPage,
        pageSize: vm.chat.pageSize,
        toUserId: vm.toUserId,
        chatSessionId: vm.chatSessionId || '',
        order: vm.order || 'desc', // 支持排序参数
        filterThink: vm.filterThink || 0
      }
      // 如果外部指定了 fromUserId，使用 targetFromUserId 字段传给后端
      if (vm.fromUserId) {
        req.targetFromUserId = vm.fromUserId
      }

      try {
        const response = await axios.post(url, req)
        vm.chat.loading = false
        vm.chat.finished = false
        if (vm.chat.refreshing) {
          vm.chat.refreshing = false
        }
        var body = response.data
        if (body.code !== 0) {
          vm.chat.finished = true
          // 如果有错误信息，存储并显示（如私有会话提示）
          // 新格式：code=1, data=错误信息字符串
          if (body.code === 1 && body.data) {
            vm.$set(vm.chat, 'errorMsg', body.data)
          } else if (body.msg) {
            vm.$set(vm.chat, 'errorMsg', body.msg)
          }
          return
        }
        var data = body.data
        for (var i = 0; i < data.chatMsgs.length; i++) {
          data.chatMsgs[i].serverReceived = 1
          if (data.chatMsgs[i].contentType == 'plaintext' || data.chatMsgs[i].contentType == 'text') {
            data.chatMsgs[i].msg = vm.parseRawContent(data.chatMsgs[i].msg)
          } else if (data.chatMsgs[i].contentType == 'mixed') {
            try {
              var contentArray = Array.isArray(data.chatMsgs[i].msg) ? data.chatMsgs[i].msg : JSON.parse(data.chatMsgs[i].msg)
              contentArray.forEach(item => {
                if (item.type === 'plaintext') {
                  item.content = vm.parseRawContent(item.content)
                }
              })
              data.chatMsgs[i].msg = contentArray
            } catch (e) {
              console.error('[ChatMsgList] Failed to parse mixed content:', e)
            }
          } else if (data.chatMsgs[i].contentType === 'assistant') {
            try {
              data.chatMsgs[i].msg = JSON.parse(data.chatMsgs[i].msg)
            } catch (e) {
              console.error('[ChatMsgList] Failed to parse assistant content:', e)
              continue
            }
            // 解析 assistant 消息中的 think 标签和 actions
            if (data.chatMsgs[i].contentType === 'assistant' &&
              data.chatMsgs[i].msg && data.chatMsgs[i].msg.msg) {
              // 先解析 think 标签（内部会自动解析 actions，确保只在非 think 文本中解析）
              const thinkParsed = vm.parseThinkTags(data.chatMsgs[i].msg.msg)
              data.chatMsgs[i].parsedMsg = vm.parseRawContent(thinkParsed.text)
              data.chatMsgs[i].thinkContent = thinkParsed.thinkContent
              data.chatMsgs[i].isThinking = thinkParsed.isThinking
              data.chatMsgs[i].parsedThinkContent = thinkParsed.thinkContent ? vm.parseRawContent(thinkParsed.thinkContent) : null
              data.chatMsgs[i].actions = thinkParsed.actions
              data.chatMsgs[i].completeness = thinkParsed.completeness
              data.chatMsgs[i].estimatedRemainingRounds = thinkParsed.estimatedRemainingRounds
              data.chatMsgs[i].userMsgOptions = thinkParsed.userMsgOptions
            }
          }
        }

        // 去重：过滤掉本地已存在的消息（避免 addMessage 和 loadChatMessages 同时添加同一条消息）
        var existingMsgIds = new Set(vm.chat.chatMsgs.map(m => m.msgId).filter(Boolean))
        var newMsgs = data.chatMsgs.filter(m => !existingMsgIds.has(m.msgId))

        // 根据排序方式处理消息列表
        if (vm.order === 'asc') {
          // 正序：消息按时间正序返回，追加到列表末尾
          vm.chat.chatMsgs = [...vm.chat.chatMsgs, ...newMsgs]
        } else {
          // 倒序（默认）：消息按时间倒序返回，index 0 = 最新 = 视觉底部
          // column-reverse 容器：追加到数组末尾 = 视觉顶部（更早的消息）
          // 滚动位置自然不变，无需 scrollHeight/scrollTop 修正！
          vm.chat.chatMsgs = [...vm.chat.chatMsgs, ...newMsgs]
        }

        if (data.chatMsgs.length < data.pageSize) {
          vm.chat.finished = true
        }

        // 初始化消息中的位置地图
        this.initLocationMaps()

        // 检查是否有需求已明确的消息
        this.checkRequirementClarified()

        // 从历史消息中提取用户第一条实质性消息（兜底 userMsg，与 client 端 ai_chat_page 逻辑一致）
        this.extractFirstUserMsgFromHistory()

        // 从最后一条 AI 消息兜底解析 userMsgOptions（对齐 client）
        this.emitLatestUserMsgOptions()

        // 从历史消息中恢复进度状态
        this.restoreProgressFromHistory()

        // 标记加载到的未读消息为已读（包括第一页和后续加载的更多历史消息）
        this.markMessagesAsRead()

        // 第一次加载时滚动处理
        if (vm.chat.curPage == 1) {
          vm.$nextTick(() => {
            setTimeout(() => {
              if (vm.order === 'asc') {
                // 正序：滚动到顶部
                vm.scrollToTop()
                // 检查是否需要继续加载（内容未填满容器时自动加载更多）
                vm.checkAndLoadMoreIfNeeded()
              } else {
                // 倒序：column-reverse 容器，滚动到底部 = scrollTop = 0
                vm.scrollToBottom()
              }
            }, 300)
          })
        } else {
          // 后续分页加载后，也需要检查是否需要继续加载
          vm.$nextTick(() => {
            setTimeout(() => {
              if (vm.order === 'asc') {
                vm.checkAndLoadMoreIfNeeded()
              } else {
                // 倒序：column-reverse 容器，检查是否需要继续加载更早消息
                vm.checkAndLoadMoreIfNeededDesc()
              }
            }, 100)
          })
        }
        vm.chat.curPage = parseInt(data.curPage) + 1
      } catch (error) {
        console.log(error)
        vm.chat.finished = true
        Toast.fail(this.$t('toast_load_data_failed'))
      }
    },
    // 标记历史消息为已读（通过 WebSocket 发送 ack）
    async markMessagesAsRead() {
      let vm = this
      // 获取当前用户ID（从 store 中获取）
      const currentUserId = this.$store.state.user && this.$store.state.user.userId
      if (!currentUserId) {
        return
      }

      // 收集所有未读消息
      const unreadMessages = vm.chat.chatMsgs.filter(msg => {
        // 只标记接收到的未读消息（direction == '1' 表示收到的消息）
        // 且接收方是当前用户（toUserId == currentUserId）
        // 且消息是未读状态（read === '0'）
        const toUserId = String(msg.toUserId)
        const readValue = String(msg.read)
        const isUnread = msg.direction === '1' &&
          toUserId === currentUserId &&
          readValue === '0'

        return isUnread
      })

      if (unreadMessages.length === 0) {
        return
      }

      // 通过 WebSocket 发送 endpoint_ack，这样对方也能感知到已读
      unreadMessages.forEach(msg => {
        wsService.sendEndpointAck(msg.msgId, msg.fromUserId)
        console.log('[ChatMsgList] Sent endpoint_ack for historical message:', msg.msgId, 'to:', msg.fromUserId)
      })

      // 更新本地消息状态
      vm.chat.chatMsgs.forEach(msg => {
        const toUserId = String(msg.toUserId)
        const readValue = String(msg.read)
        if (msg.direction === '1' &&
          toUserId === currentUserId &&
          readValue === '0') {
          msg.read = '1'
        }
      })
    },
    // 加载会话信息
    // async loadChatSession() {
    //   let vm = this
    //   if (!vm.chatSessionId) {
    //     return
    //   }
    //   try {
    //     var url = '/api/chat/get_chat_session'
    //     var req = { chatSessionId: vm.chatSessionId }
    //     const response = await axios.post(url, req)
    //     var body = response.data
    //     if (body.code === 0 && body.data && body.data.chatSession) {
    //       var chatSession = body.data.chatSession
    //       if (chatSession.requirementClarified === 1 || chatSession.requirementClarified === '1') {
    //         vm.requirementClarified = '1'
    //       }
    //       if (chatSession.public === 1 || chatSession.public === '1') {
    //         vm.public = '1'
    //       } else {
    //         vm.public = '0'
    //       }
    //     }
    //   } catch (error) {
    //     console.error('拉取chatSession失败:', error)
    //   }
    // },
    // 滚动处理（无限滚动加载更多）
    handleChatScroll() {
      const container = this.$refs.infiniteChatScrollContainer
      if (!container || this.chat.loading) return

      if (this.order === 'asc') {
        // 正序：滚动到底部时加载更新的消息
        if (container.scrollHeight - container.scrollTop - container.clientHeight <= 30) {
          this.loadChatMessages()
        }
      } else {
        // 倒序（默认）：column-reverse 容器
        // scrollTop = 0 → 视觉底部（最新消息）
        // scrollTop = -(scrollHeight - clientHeight) → 视觉顶部（更早消息）
        // 滚动到视觉顶部 = 加载更早消息
        const minScroll = -(container.scrollHeight - container.clientHeight)
        if (container.scrollTop <= minScroll + 30) {
          this.loadChatMessages()
        }
      }
    },
    // 检查是否需要继续加载（内容未填满容器时自动加载更多）
    checkAndLoadMoreIfNeeded() {
      const container = this.$refs.infiniteChatScrollContainer
      if (!container || this.chat.loading || this.chat.finished) return

      // 如果内容高度小于等于容器高度，说明没有填满，需要继续加载
      if (container.scrollHeight <= container.clientHeight + 30) {
        this.loadChatMessages()
      }
    },
    // 倒序模式下检查是否需要继续加载（column-reverse 容器，内容未填满时自动加载更多）
    checkAndLoadMoreIfNeededDesc() {
      const container = this.$refs.infiniteChatScrollContainer
      if (!container || this.chat.loading || this.chat.finished) return

      // column-reverse 容器：如果 scrollHeight <= clientHeight，说明没有填满
      // 此时 scrollTop = 0（底部），需要继续加载更早消息
      if (container.scrollHeight <= container.clientHeight + 30) {
        this.loadChatMessages()
      }
    },
    // 滚动到顶部
    scrollToTop() {
      var scrollableDiv = this.$refs.infiniteChatScrollContainer
      if (scrollableDiv) {
        // column-reverse 容器：视觉顶部 = scrollTop 最小值（负值）
        scrollableDiv.scrollTop = -(scrollableDiv.scrollHeight - scrollableDiv.clientHeight)
      }
    },
    // 添加消息（外部调用）
    addMessage(msg) {
      let vm = this

      console.log('[DEBUG] ChatMsgList.addMessage - 接收到消息:', {
        msgId: msg.msgId,
        fromUserId: msg.fromUserId,
        toUserId: msg.toUserId,
        chatSessionId: msg.chatSessionId,
        direction: msg.direction,
        contentType: msg.contentType
      })
      console.log('[DEBUG] ChatMsgList.addMessage - 当前 chatMsgs 数量:', this.chat.chatMsgs.length)

      // 去重检查：如果 msgId 已存在，则跳过（避免 addMessage 和 loadChatMessages 同时添加同一条消息）
      if (msg.msgId && this.chat.chatMsgs.some(m => m.msgId === msg.msgId)) {
        console.log('[DEBUG] ChatMsgList.addMessage - 消息已存在，跳过重复添加，msgId:', msg.msgId)
        return
      }

      // 解析消息内容
      if (msg.contentType == 'plaintext' || msg.contentType == 'text') {
        msg.msg = vm.parseRawContent(msg.msg)
      } else if (msg.contentType == 'assistant') {
        if (typeof msg.msg === 'string') {
          try {
            msg.msg = JSON.parse(msg.msg)
          } catch (e) {
            console.error('[ChatMsgList] Failed to parse assistant content:', e)
            return // 解析失败则不继续处理
          }
        }
        // 解析 assistant 消息中的 think 标签和 actions
        if (msg.msg && msg.msg.msg) {
          // 先解析 think 标签（内部会自动解析 actions，确保只在非 think 文本中解析）
          const thinkParsed = vm.parseThinkTags(msg.msg.msg)
          msg.parsedMsg = vm.parseRawContent(thinkParsed.text)
          msg.thinkContent = thinkParsed.thinkContent
          msg.isThinking = thinkParsed.isThinking
          msg.parsedThinkContent = thinkParsed.thinkContent ? vm.parseRawContent(thinkParsed.thinkContent) : null
          msg.actions = thinkParsed.actions
          msg.completeness = thinkParsed.completeness
          msg.estimatedRemainingRounds = thinkParsed.estimatedRemainingRounds
          msg.userMsgOptions = thinkParsed.userMsgOptions
          // 如果包含 requirement_clarified，通知父组件
          if (vm.hasRequirementClarified(thinkParsed.actions)) {
            vm.$emit('requirement-clarified')
          }
          // 如果包含进度信息，通知父组件
          if (thinkParsed.completeness != null || thinkParsed.estimatedRemainingRounds != null) {
            vm.$emit('progress-update', {
              completeness: thinkParsed.completeness,
              estimatedRemainingRounds: thinkParsed.estimatedRemainingRounds
            })
          }
          // 兜底解析 userMsgOptions（对齐 client）
          vm.emitLatestUserMsgOptions()
        }
      } else if (msg.contentType == 'mixed') {
        if (typeof msg.msg === 'string') {
          try {
            var contentArray = JSON.parse(msg.msg)
            contentArray.forEach(item => {
              if (item.type === 'plaintext') {
                item.content = vm.parseRawContent(item.content)
              }
            })
            msg.msg = contentArray
          } catch (e) {
            console.error('[ChatMsgList] Failed to parse mixed content:', e, 'msg.msg:', msg.msg)
            // 如果解析失败，保持原值不做处理
          }
        }
      }

      // 设置时间文本
      if (!msg.createdAtText) {
        msg.createdAtText = vm.$common ? vm.$common.formatDateTime(msg.createdAt) : ''
      }

      vm.chat.chatMsgs.unshift(msg)

      console.log('[DEBUG] ChatMsgList.addMessage - 消息已添加，chatMsgs 数量:', this.chat.chatMsgs.length)

      // 初始化新消息中的位置地图（如果有）
      if (msg.contentType === 'mixed' && Array.isArray(msg.msg)) {
        this.$nextTick(() => {
          msg.msg.forEach((item, index) => {
            if (item.type === 'pick_location' && item.content) {
              const mapKey = `${msg.msgId}-${index}`
              const refName = `locationMap-${msg.msgId}-${index}`
              this.initReadonlyLocationMap(refName, item.content, mapKey)
            }
          })
        })
      }

      // 滚动到底部
      setTimeout(() => {
        vm.scrollToBottom()
      }, 100)

      // 更新需求澄清状态
      // if (msg.msg && msg.msg.requirementClarified === '1') {
      //   vm.requirementClarified = '1'
      // }
    },
    // 追加流式消息内容（外部调用）
    appendStreamMessage(msgId, content) {
      let vm = this
      var existingMsgIndex = -1
      for (var i = vm.chat.chatMsgs.length - 1; i >= 0; i--) {
        if (vm.chat.chatMsgs[i].msgId == msgId) {
          existingMsgIndex = i
          break
        }
      }

      if (existingMsgIndex >= 0) {
        // 追加内容到现有消息
        if (typeof vm.chat.chatMsgs[existingMsgIndex].msg === 'string') {
          vm.chat.chatMsgs[existingMsgIndex].msg += content
        } else if (typeof vm.chat.chatMsgs[existingMsgIndex].msg === 'object') {
          if (vm.chat.chatMsgs[existingMsgIndex].msg.msg !== undefined) {
            vm.chat.chatMsgs[existingMsgIndex].msg.msg += content
          }
        }

        // 对于 assistant 类型消息，重新解析 think 标签和 actions
        if (vm.chat.chatMsgs[existingMsgIndex].contentType === 'assistant' &&
          vm.chat.chatMsgs[existingMsgIndex].msg &&
          vm.chat.chatMsgs[existingMsgIndex].msg.msg) {
          // 先解析 think 标签（内部会自动解析 actions，确保只在非 think 文本中解析）
          const thinkParsed = vm.parseThinkTags(vm.chat.chatMsgs[existingMsgIndex].msg.msg)
          vm.chat.chatMsgs[existingMsgIndex].parsedMsg = vm.parseRawContent(thinkParsed.text)
          vm.chat.chatMsgs[existingMsgIndex].thinkContent = thinkParsed.thinkContent
          vm.chat.chatMsgs[existingMsgIndex].isThinking = thinkParsed.isThinking
          vm.chat.chatMsgs[existingMsgIndex].parsedThinkContent = thinkParsed.thinkContent ? vm.parseRawContent(thinkParsed.thinkContent) : null
          vm.chat.chatMsgs[existingMsgIndex].actions = thinkParsed.actions
          vm.chat.chatMsgs[existingMsgIndex].completeness = thinkParsed.completeness
          vm.chat.chatMsgs[existingMsgIndex].estimatedRemainingRounds = thinkParsed.estimatedRemainingRounds
          vm.chat.chatMsgs[existingMsgIndex].userMsgOptions = thinkParsed.userMsgOptions
          // 如果包含 requirement_clarified，通知父组件
          if (vm.hasRequirementClarified(thinkParsed.actions)) {
            vm.$emit('requirement-clarified')
          }
          // 如果包含进度信息，通知父组件
          if (thinkParsed.completeness != null || thinkParsed.estimatedRemainingRounds != null) {
            vm.$emit('progress-update', {
              completeness: thinkParsed.completeness,
              estimatedRemainingRounds: thinkParsed.estimatedRemainingRounds
            })
          }
          // 兜底解析 userMsgOptions（对齐 client）
          vm.emitLatestUserMsgOptions()
          // 如果正在思考中，自动滚动 think 框到底部
          if (vm.chat.chatMsgs[existingMsgIndex].isThinking) {
            vm.scrollThinkBoxToBottom(msgId)
          }
        }

        // 强制更新
        vm.chat.chatMsgs = [...vm.chat.chatMsgs]

        // 如果不是思考状态，滚动到底部以便查看最新内容
        if (!vm.chat.chatMsgs[existingMsgIndex].isThinking) {
          vm.$nextTick(() => {
            vm.scrollToBottom()
          })
        }
      }
    },
    // 更新消息已读状态（外部调用）
    updateMessageRead(msgId) {
      for (var i = 0; i < this.chat.chatMsgs.length; i++) {
        if (this.chat.chatMsgs[i].msgId == msgId) {
          this.chat.chatMsgs[i].read = '1'
          break
        }
      }
    },
    // 更新消息服务端接收状态（外部调用）
    updateMessageServerReceived(msgId) {
      console.log('[DEBUG] ChatMsgList.updateMessageServerReceived - msgId:', msgId, 'chatMsgs 数量:', this.chat.chatMsgs.length)
      for (var i = 0; i < this.chat.chatMsgs.length; i++) {
        if (this.chat.chatMsgs[i].msgId == msgId) {
          console.log('[DEBUG] ChatMsgList.updateMessageServerReceived - 找到消息，更新 serverReceived 状态')
          this.chat.chatMsgs[i].serverReceived = '1'
          break
        }
      }
      // 强制触发 Vue 响应式更新
      this.chat.chatMsgs = [...this.chat.chatMsgs]
      console.log('[DEBUG] ChatMsgList.updateMessageServerReceived - 更新完成')
    },
    // 更新消息发送状态（外部调用）
    updateMessageSendStatus(msgId, status, errorMessage) {
      console.log('[DEBUG] ChatMsgList.updateMessageSendStatus - msgId:', msgId, 'status:', status, 'errorMessage:', errorMessage)
      for (var i = 0; i < this.chat.chatMsgs.length; i++) {
        if (this.chat.chatMsgs[i].msgId == msgId) {
          console.log('[DEBUG] ChatMsgList.updateMessageSendStatus - 找到消息，更新 sendStatus 状态')
          this.chat.chatMsgs[i].sendStatus = status
          if (errorMessage) {
            this.chat.chatMsgs[i].errorMessage = errorMessage
          }
          break
        }
      }
      // 强制触发 Vue 响应式更新
      this.chat.chatMsgs = [...this.chat.chatMsgs]
      console.log('[DEBUG] ChatMsgList.updateMessageSendStatus - 更新完成')
    },
    // 重试发送消息
    retrySendMessage(record) {
      console.log('[DEBUG] 重试发送消息 - msgId:', record.msgId)

      // 构建消息数据
      var msgData = {
        msgId: record.msgId,
        chatSessionId: record.chatSessionId || this.chatSessionId,
        toUserId: record.toUserId,
        contentType: record.contentType,
        msg: record.msg,
        // 引用信息原样重发
        reply: record.reply || undefined
      }

      // 重新发送消息
      var success = wsService.sendMessage(msgData)

      if (success) {
        // 发送成功，重置状态为 sending
        this.updateMessageSendStatus(record.msgId, 'sending')
        console.log('[DEBUG] 重试发送消息成功')
      } else {
        // 仍然失败，保持 failed 状态并更新错误消息
        this.updateMessageSendStatus(record.msgId, 'failed', 'Network disconnected')
        console.log('[DEBUG] 重试发送消息失败')
      }
    },
    // 滚动到底部
    scrollToBottom() {
      var scrollableDiv = this.$refs.infiniteChatScrollContainer
      if (scrollableDiv) {
        // column-reverse 容器：视觉底部 = scrollTop = 0
        scrollableDiv.scrollTop = 0
      }
    },
    // 滚动到指定位置
    scrollToPosition(top) {
      var scrollableDiv = this.$refs.infiniteChatScrollContainer
      if (scrollableDiv) {
        // column-reverse 容器：scrollTop = 0 是视觉底部
        // top 是从视觉顶部算的偏移，需要转换为 scrollTop
        scrollableDiv.scrollTop = -(top)
      }
    },
    // 获取当前消息列表
    getChatMsgs() {
      return this.chat.chatMsgs
    },
    // 获取加载状态
    getLoadingState() {
      return {
        loading: this.chat.loading,
        finished: this.chat.finished,
        curPage: this.chat.curPage
      }
    },
    // 图片点击事件
    handleImageClick(url) {
      this.$emit('image-click', url)
    },
    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
        closeIcon: 'cross',
        closeIconPosition: 'top-right',
        closeOnClickOverlay: true,
        showIndex: false
      })
    },
    // 滚动事件
    handleScroll(event) {
      this.$emit('scroll', event)
    },
    // ============ 举报相关方法 ============
    // 触摸开始（用于检测长按）
    handleTouchStart(record, event) {
      if (record.system === '1' || record.revoked == '1') {
        return
      }
      this.touchTimer = setTimeout(() => {
        this.showMessageActions(record, event)
      }, 600) // 600ms 视为长按
    },
    // 触摸结束
    handleTouchEnd(event) {
      if (this.touchTimer) {
        clearTimeout(this.touchTimer)
        this.touchTimer = null
      }
    },
    // 显示消息操作菜单（长按/右键消息）
    showMessageActions(record, event) {
      if (record.system === '1') {
        return
      }
      // 只在私聊中显示消息操作菜单，AI聊天不显示
      if (!this.isUserChat) {
        return
      }
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      
      this.selectedMsg = record
      if (record.direction == '0') {
        // 自己发送的消息：提供撤回/引用入口（已撤回消息不响应；服务端二次校验发送者身份与时限）
        if (record.revoked == '1') {
          return
        }
        this.actionMenuItems = [
          { name: this.$t('msg_revoke'), value: 'revoke' },
          { name: this.$t('msg_quote'), value: 'quote' }
        ]
      } else {
        // 对方发来的消息：引用/举报/屏蔽
        this.actionMenuItems = [
          { name: this.$t('msg_quote'), value: 'quote' },
          { name: this.$t('report_message'), value: 'report' },
          { name: this.$t('block_user'), value: 'block' }
        ]
      }
      this.showActionMenu = true
    },
    // 处理操作菜单选择
    onActionMenuSelect(action) {
      this.showActionMenu = false
      if (!this.selectedMsg) return
      
      const msgId = this.selectedMsg.msgId
      const reportedUserId = this.selectedMsg.fromUserId
      
      if (action.value === 'revoke') {
        // 撤回自己发送的消息
        this.revokeMessage(msgId)
      } else if (action.value === 'quote') {
        // 引用（回复）该消息：交给 ChatBox 设置引用条并随下一条消息发送
        this.$emit('reply', this.selectedMsg)
      } else if (action.value === 'report') {
        // 打开举报对话框
        this.$refs.reportDialog.open(msgId, reportedUserId)
      } else if (action.value === 'block') {
        // 直接屏蔽用户
        this.blockUser(reportedUserId)
      }
    },
    // 引用块展示文本：被引用消息在当前消息流中且已撤回时，显示撤回提示而非原摘要
    replySummaryText(record) {
      const replyObj = this.parseReply(record)
      if (!replyObj) return ''
      const orig = this.chat.chatMsgs.find(m => m.msgId == replyObj.msgId)
      if (orig && orig.revoked == '1') {
        // 统一用中性文案：撤回者是被引用消息的发送者，与当前消息的方向无关
        return this.$t('msg_revoked_generic')
      }
      return replyObj.msg || ''
    },
    // 引用块展示的被引用人名字
    replyNameText(record) {
      const replyObj = this.parseReply(record)
      if (!replyObj) return ''
      return replyObj.name || ''
    },
    // 解析引用信息，兼容 string（个别后端路径未 parse）
    parseReply(record) {
      const reply = record.reply
      if (!reply) return null
      if (typeof reply === 'string') {
        try { return JSON.parse(reply) } catch (e) { return null }
      }
      return reply
    },
    // 撤回自己发送的消息：WS 优先（服务端撤回后向双方广播实时事件），断线时 HTTP 兜底
    async revokeMessage(msgId) {
      const record = this.chat.chatMsgs.find(m => m.msgId == msgId)
      const toUserId = record ? record.toUserId : ''
      try {
        const resp = await wsService.sendMsgRevoke(msgId, toUserId)
        if (resp && resp.code == 0) {
          // 乐观更新本地展示；服务端 msg_revoke 广播到达后 revokeMessageLocally 幂等再更新
          this.revokeMessageLocally(msgId)
          Toast.success(this.$t('toast_revoke_success'))
        } else {
          Toast.fail((resp && resp.data) || this.$t('toast_revoke_failed'))
        }
      } catch (error) {
        console.error('Revoke message error:', error)
        Toast.fail(this.$t('toast_revoke_failed'))
      }
    },
    // 本地更新消息为已撤回（服务端 msg_revoke 广播 / 乐观更新共用）：占位保留，内容不再展示
    revokeMessageLocally(msgId) {
      for (var i = 0; i < this.chat.chatMsgs.length; i++) {
        if (this.chat.chatMsgs[i].msgId == msgId) {
          this.chat.chatMsgs[i].revoked = '1'
          break
        }
      }
      // 强制触发 Vue 响应式更新
      this.chat.chatMsgs = [...this.chat.chatMsgs]
    },
    // 本地标记消息被平台屏蔽（msg_blocked 实时事件）：内容保留，标记 blocked 走历史消息同一渲染分支
    // blockReason 为服务端排查文案，存到 record 供 title 展示，不做用户可见文案
    markMessageBlockedLocally(msgId, blockReason) {
      for (var i = 0; i < this.chat.chatMsgs.length; i++) {
        if (this.chat.chatMsgs[i].msgId == msgId) {
          this.chat.chatMsgs[i].blocked = '1'
          if (blockReason) {
            this.chat.chatMsgs[i].blockReason = blockReason
          }
          break
        }
      }
      // 强制触发 Vue 响应式更新（同 revokeMessageLocally）
      this.chat.chatMsgs = [...this.chat.chatMsgs]
    },
    async blockUser(blockedUserId) {
      try {
        const response = await axios.post('/api/user/block_user', {
          userId: this.currentUserId,
          blockedUserId: blockedUserId
        })
        if (response.data.code === 0) {
          Toast.success(this.$t('toast_block_success'))
        } else {
          Toast.fail(response.data.data || this.$t('toast_block_failed'))
        }
      } catch (error) {
        console.error('Block user error:', error)
        Toast.fail(this.$t('toast_block_failed'))
      }
    },
    // 下载文件
    downloadFile(fileContent) {
      if (!fileContent || !fileContent.url) {
        Toast.fail(this.$t('toast_file_url_missing'))
        return
      }
      const fileUrl = this.$common.getFullImageUrl(fileContent.url, this.$config)
      window.open(fileUrl, '_blank')
    },
    // ============ 视频全屏播放 ============
    // 打开全屏播放器（此时才开始下载视频）
    openVideoPlayer(videoUrl) {
      if (!videoUrl) return
      this.videoPlayerUrl = videoUrl
    },
    // 关闭全屏播放器（v-if 销毁 video 元素，自动停止下载/播放）
    closeVideoPlayer() {
      this.videoPlayerUrl = ''
    },
    // ============ 语音消息播放 ============
    // 获取播放器元素（防御：万一 ref 被收集成数组则取第一个）
    getAudioPlayerEl() {
      const ref = this.$refs.audioPlayer
      if (Array.isArray(ref)) return ref[0] || null
      return ref || null
    },
    // 播放/暂停语音
    toggleAudioPlay(item, msgId) {
      const player = this.getAudioPlayerEl()
      if (!player || typeof player.play !== 'function') return
      // 缓冲中忽略重复点击
      if (this.audioLoadingMsgId == msgId) return
      // 正在播这条 → 暂停
      if (this.audioPlayingMsgId == msgId) {
        player.pause()
        this.audioPlayingMsgId = null
        return
      }
      const url = this.$common.getFullImageUrl(item.content.url, this.$config)
      if (!url) return
      // 切换到新的一条：重置进度状态，标记缓冲中（慢网络下首帧前显示 loading）
      this.audioCurrentTime = 0
      this.audioDuration = 0
      this.audioPlayingMsgId = msgId
      this.audioLoadingMsgId = msgId
      player.src = url
      player.play().catch((e) => {
        console.error('[ChatMsgList] Play audio failed:', e)
        this.audioPlayingMsgId = null
        this.audioLoadingMsgId = null
        Toast(this.$t('voice_load_failed'))
      })
    },
    // 浏览器实际开始播放（缓冲完成），解除 loading
    onAudioPlaying() {
      this.audioLoadingMsgId = null
    },
    // 缓冲/加载出错（断网、404 等），复位状态避免图标卡死
    onAudioError() {
      if (this.audioLoadingMsgId == null && this.audioPlayingMsgId == null) return
      this.audioLoadingMsgId = null
      this.audioPlayingMsgId = null
      Toast(this.$t('voice_load_failed'))
    },
    onAudioEnded() {
      // 播放结束：position 停在末尾，再点一次从头播
      if (this.audioDuration > 0) {
        this.audioCurrentTime = this.audioDuration
      }
      this.audioPlayingMsgId = null
    },
    onAudioTimeUpdate() {
      const player = this.getAudioPlayerEl()
      if (player && this.audioPlayingMsgId) {
        this.audioCurrentTime = player.currentTime || 0
      }
    },
    onAudioLoadedMetadata() {
      const player = this.getAudioPlayerEl()
      if (player && this.audioPlayingMsgId) {
        const d = player.duration
        if (d && isFinite(d)) {
          this.audioDuration = d
        }
      }
    },
    // 是否正在播这条（显示暂停图标）
    isAudioPlaying(msgId) {
      return this.audioPlayingMsgId == msgId
    },
    // 播放进度百分比
    getAudioProgress(msgId) {
      if (this.audioPlayingMsgId != msgId || this.audioDuration <= 0) return 0
      const p = (this.audioCurrentTime / this.audioDuration) * 100
      return Math.min(100, Math.max(0, p))
    },
    // 显示时长：播放中显示已播放时长，否则显示总时长（后端 duration 秒 / 元数据时长兜底）
    getAudioDurationText(msgDuration, msgId) {
      if (this.audioPlayingMsgId == msgId) {
        return this.formatAudioSeconds(this.audioCurrentTime)
      }
      const d = parseInt(msgDuration, 10)
      if (d && !isNaN(d) && d > 0) {
        return this.formatAudioSeconds(d)
      }
      if (this.audioDuration > 0) {
        return this.formatAudioSeconds(this.audioDuration)
      }
      return this.formatAudioSeconds(0)
    },
    // 秒 → m:ss
    formatAudioSeconds(seconds) {
      const total = Math.floor(seconds || 0)
      const m = Math.floor(total / 60)
      const s = total % 60
      return m + ':' + (s < 10 ? '0' : '') + s
    },
    // 格式化文件大小
    formatFileSize(bytes) {
      if (!bytes || bytes <= 0) return '0 B'
      if (bytes < 1024) {
        return bytes + ' B'
      } else if (bytes < 1024 * 1024) {
        return (bytes / 1024).toFixed(1) + ' KB'
      } else {
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
      }
    },
    // 解析emoji为twemoji图片
    parseEmoji(emoji) {
      return twemoji.parse(emoji, {
        className: 'msg-emoji-img',
        base: this.$publicPath + 'static/twemoji/',
        size: 'svg',
        ext: '.svg'
      });
    }
    // ============ 举报相关方法结束 ============
  }
}
</script>

<style scoped>
/* 微信风格消息布局 */
.message-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

/* 已撤回消息占位：保留消息位置，仅展示灰色提示 */
.message-revoked-row {
  justify-content: center;
}

.msg-revoked-text {
  font-size: 0.75rem;
  color: #8A8A8A;
  background: #F7F5F2;
  padding: 4px 12px;
  border-radius: 4px;
}

/* 被平台屏蔽的消息：气泡底部灰色小字标记（内容保留展示） */
.msg-blocked-row {
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  color: #8A8A8A;
  margin-top: 2px;
}

/* 引用块：竖线+摘要，微信/Telegram 风格 */
.msg-reply-block {
  margin-bottom: 4px;
  padding: 3px 6px;
  background: rgba(0, 0, 0, 0.04);
  border-left: 2px solid #E8543A;
  border-radius: 3px;
  max-width: 220px;
}

.msg-reply-name {
  font-size: 0.7rem;
  color: #E8543A;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.msg-reply-summary {
  font-size: 0.7rem;
  color: #4A4A4A;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  text-align: left;
}

.message-left {
  justify-content: flex-start;
  text-align: left;
}

.message-right {
  justify-content: flex-end;
  text-align: left;
}

.message-avatar {
  flex-shrink: 0;
  margin: 0 8px;
}

.avatar-img {
  width: 36px;
  height: 36px;
  border-radius: 16%;
  object-fit: cover;
  background-color: #FEF0ED;
}

.ai-thinking-spin {
  animation: ai-thinking-spin-anim 3s linear infinite;
}

.thinking-latest-text {
  margin-left: 6px;
  overflow: hidden;
  white-space: nowrap;
  direction: rtl;
  flex: 1;
  min-width: 0;
}
.thinking-latest-text span {
  direction: ltr;
  display: inline-block;
}

@keyframes ai-thinking-spin-anim {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.avatar-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 16%;
  background-color: #8A8A8A;
  color: white;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-placeholder-self {
  background-color: #E8543A;
}

.message-content-wrapper {
  max-width: 70%;
}

.msg-left {
  text-align: left;
}

.msg-right {
  text-align: right;
}

/* 对方消息（接收的消息）- 白色气泡，小圆角 */
.message-left .msg-body {
  background: #FFFFFF;
  padding: 10px 12px;
  border-radius: 4px;
  position: relative;
  margin-left: 4px;
}

/* 自己发送的消息 - 淡橙色背景，稍大圆角 */
.message-right .msg-body {
  background: #FEF0ED;
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
  margin-right: 4px;
}

/* 小箭头 - 使用伪元素实现 */
.message-left .msg-body::before {
  content: '';
  position: absolute;
  left: -5px;
  top: 8px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #FFFFFF;
}

.message-right .msg-body::before {
  content: '';
  position: absolute;
  right: -6px;
  top: 8px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #FEF0ED;
}

.msg-body-sent {
  background: #FEF0ED !important;
  border: none !important;
}

.msg-body>>>.twemoji {
  width: 20px !important;
  height: 20px !important;
  position: relative;
  top: 8px;
  padding: 2px;
}

.msg-body>>>.twemoji svg {
  width: 100% !important;
  height: 100% !important;
  vertical-align: top;
}

.html-content {
  -webkit-user-select: text;
  user-select: text;
  -webkit-touch-callout: default;
  font-size: 14px;
  color: #1A1A1A;
  line-height: 1.5;
}

.msg-image {
  max-width: 200px;
  max-height: 200px;
  border-radius: 4px;
  margin-top: 8px;
  cursor: pointer;
}

/* 视频消息样式 */
.msg-video-wrapper {
  margin-top: 8px;
}

/* 列表中的视频缩略图（不加载视频，仅展示首帧） */
.msg-video-poster {
  position: relative;
  width: 200px;
  height: 130px;
  border-radius: 4px;
  overflow: hidden;
  background: #1A1A1A;
  cursor: pointer;
}

.msg-video-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.msg-video-thumb-empty {
  /* 无缩略图（历史消息）时的深色兜底 */
  background: #1A1A1A;
}

.msg-video-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding-left: 3px;
}

/* 视频全屏播放器遮罩 */
.video-player-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-player-video {
  /* 按视频实际尺寸/比例展示，最大不超过视口 */
  max-width: 92vw;
  max-height: 85vh;
  width: auto;
  height: auto;
  background: #000;
}

.video-player-close {
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 14px);
  right: 18px;
  cursor: pointer;
  z-index: 1;
}

/* 位置地图样式 */
.msg-location-wrapper {
  margin: 8px 0px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E0DDD8;
  background: #F7F5F2;
}

.msg-location-map {
  width: 100%;
  height: 150px;
  min-width: 200px;
}

.msg-location-info {
  padding: 6px 10px;
  font-size: 12px;
  color: #8A8A8A;
  background: white;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 文件样式 */
.msg-file-wrapper {
  margin: 8px 0px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #E8F7FB;
  background: #E8F7FB;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.msg-file-wrapper:hover {
  background: #E8F7FB;
}

.msg-file-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  overflow: hidden;
}

.msg-file-name {
  font-size: 13px;
  color: #1A1A1A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.msg-file-size {
  font-size: 11px;
  color: #8A8A8A;
}

/* 语音消息样式 */
.msg-audio-wrapper {
  margin: 8px 0px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #F8A090;
  background: #FEF0ED;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  max-width: 240px;
}

.msg-audio-play-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #E8543A;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.msg-audio-play-btn:active {
  opacity: 0.85;
}

/* 缓冲 loading：白色转圈（暗轨道衬托，与"播放中"图标区分） */
.msg-audio-loading {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2.5px solid rgba(0, 0, 0, 0.28);
  border-top-color: #fff;
  animation: msg-audio-spin 0.8s linear infinite;
}

@keyframes msg-audio-spin {
  to { transform: rotate(360deg); }
}

.msg-audio-progress-track {
  flex: 1;
  height: 4px;
  border-radius: 2px;
  background: rgba(232, 84, 58, 0.15);
  overflow: hidden;
}

.msg-audio-progress-fill {
  height: 100%;
  border-radius: 2px;
  background: #E8543A;
  transition: width 0.2s linear;
}

.msg-audio-duration {
  font-size: 11px;
  color: #C93E1A;
  flex-shrink: 0;
  min-width: 30px;
  text-align: right;
}

/* Emoji样式 */
.msg-emoji-wrapper {
  margin: 8px 0px;
  display: inline-block;
}

.msg-emoji {
  display: inline-block;
  font-size: 48px;
  line-height: 1;
}

.msg-emoji-img {
  width: 48px;
  height: 48px;
  vertical-align: middle;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* column-reverse 容器：index 0 在视觉底部，index last 在视觉顶部 */
/* 等同于 Flutter 的 reverse: true，加载更早消息追加到数组末尾 = 视觉顶部，滚动位置自然不变 */
.chat-scroll-reverse {
  display: flex;
  flex-direction: column-reverse;
  /* 聊天消息区默认底色（灰底衬托白色气泡）；父级传 chatMsgListStyle.backgroundColor 时以内联为准 */
  background: #ECEAE6;
}

/* 占位元素（DOM 第一个子元素 = 视觉最底部）：内容不足一屏时 auto margin 吸收全部剩余空间，
   把消息整体推到顶部；内容超出一屏时 auto margin 自动为 0，不影响任何滚动/加载逻辑 */
.chat-scroll-bottom-spacer {
  margin-bottom: auto;
}

/* 搜索结果定位：目标消息高亮闪烁 */
.msg-locate-highlight {
  animation: msgLocateBlink 2.5s ease;
  border-radius: 8px;
}

@keyframes msgLocateBlink {
  0%, 50% {
    background-color: rgba(240, 112, 88, 0.14);
  }
  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatMsgList.vue